import React from "react";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  tableCellRoot: {
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 12,
    paddingBottom: 12,
    fontSize: 16,
    letterSpacing: 0.4,
    color: theme.palette.common.dark,
    fontWeight: theme.typography.bold,
    borderBottom: "0 none",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
}));

const SectionTicketsTableHading = () => {
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell className={classes.tableCellRoot}>
        نام و نام خانوادگی
      </TableCell>
      <TableCell className={classes.tableCellRoot}>کدپرسنلی</TableCell>
      <TableCell className={classes.tableCellRoot}>کد ملی</TableCell>
      <TableCell className={classes.tableCellRoot}>تعداد نفرات</TableCell>
      <TableCell className={classes.tableCellRoot}>نام رخداد</TableCell>
      <TableCell className={classes.tableCellRoot}>نام سانس</TableCell>
      <TableCell className={classes.tableCellRoot}>حذف</TableCell>
    </TableRow>
  );
};

export default SectionTicketsTableHading;